export const COMMENTS_ACTION = {
  GET_COMMENTS_LIST: "COMMENTS_ACTION/GET_COMMENTS_LIST",
  CREATE_COMMENT: "COMMENTS_ACTION/CREATE_COMMENT",
  CLEAR_COMMENTS_LIST: "COMMENTS_ACTION/CLEAR_COMMENTS_LIST",
};
